import { Theme } from '@mui/material/styles'

import { GROUP_LABEL_SX } from '../groupLabel'
import { onHover, selectedState } from '../interaction'

// ----------------------------------------------------------------------

export default function List(theme: Theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          ...onHover({ backgroundColor: theme.palette.action.hover }),
          // The kit's selected state, as MuiMenuItem in Menu.ts: a ListItemButton (org switcher,
          // settings side lists, pickers) has no checkbox beside it, so medium weight is the second cue.
          '&.Mui-selected': {
            ...selectedState(theme),
            fontWeight: theme.typography.fontWeightMedium,
          },
        },
      },
    },
    /**
     * A menu's group heading in the list's group-heading voice (GROUP_LABEL_SX), so "Customer lists"
     * in a select reads the same as "Last month" over the rows. MUI's own sticky stays on: in a long
     * group the heading stays at the menu's top while its options scroll under it. Opaque, since
     * the options pass beneath it.
     */
    MuiListSubheader: {
      styleOverrides: {
        root: {
          ...GROUP_LABEL_SX,
          lineHeight: 'normal',
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.paper,
          padding: theme.spacing(1.5, 2, 0.5),
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          minWidth: 'auto',
          marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0,
        },
        multiline: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
  }
}
